import type { TransactionsFilters } from '@cpce/shared';
import { financialAccountsQueryKeys } from '@/api/financial-accounts/financial-accounts.query-keys';
import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['transactions']);

export const transactionsQueryKeys = {
  all: builder(),
  filtered: (filters: TransactionsFilters) => builder('filtered', filters),
  one: (id: number) => builder('one', id),
  infinite: (params: object) => builder('infinite', params),
  totals: (params: object) => builder('totals', params),
};

/** For a change that rewrites écritures: balances and écriture lists are stale. */
export const ECRITURES_REWRITE_INVALIDATIONS = [
  transactionsQueryKeys.all,
  financialAccountsQueryKeys.all,
];
